import {MatchesInfoText, MatchesTable, TableHeader, TableSubheader} from "./Matches.styles";
import SectionContainer from "../../components/section-items/SectionContainer/SectionContainer";
import SectionTitle from "../../components/section-items/SectionTitle/SectionTitle";
import SectionText from "../../components/section-items/SectionText/SectionText";
import SectionButton from "../../components/section-items/SectionButton/SectionButton";
import React, {useEffect, useState} from "react";
import Match from "./Match/Match";
import {ColoredText} from "../../parts/Navbar/Navbar.styles";
import Logo from "../../components/logos/Logo/Logo";
import Section from "../../components/section-items/Section/Section";
import {fetchData, fetchLatest} from "../../helpers/fetchData";
import LoadingSpinner from "../../components/spinners/LoadingSpinner";

const Matches = () => {

    const [matches, setMatches] = useState([]);
    const [winStreak, setWinStreak] = useState(0);
    const [isFetching, setIsFetching] = useState(true);

    useEffect(() => {
        fetchLatest('matches')
            .then((res) => setMatches(res))
            .then(() => setIsFetching(false))
            .catch((e) => console.error(e));

        fetchData('statistics')
            .then((res) => setWinStreak(res?.win_streak))
            .catch((e) => console.error(e));
    }, []);

    const renderMatches = () => {
        return matches?.map((e, index) =>
            <Match key={e.date + index}
                   date={e.date}
                   enemyName={e.enemy_name}
                   result={e.result}
                   clubGoals={e.club_goals}
                   enemyGoals={e.enemy_goals}/>
        );
    };

    return (<Section theme={'dark'}>
        <SectionContainer style={{flex: 1}}>
            <SectionTitle color={'white'}>{'OSTATNIE SPOTKANIA'}</SectionTitle>
            <SectionText
                color={'white'}>{'Śledź ostatnie spotkania rozegrane przez naszą drużynę. W sekcji Rywalizacja znajdziesz wyniki oraz szczegółowe dane dotyczące ostatnich rozegranych przez nas spotkań a także informacje na temat poszczególnych turniejów. Wszystkie wyniki meczów dodawane są na bieżąco po zakończeniu spotkania.'}</SectionText>
            <SectionButton text={'PRZEJDŹ DO SEKCJI RYWALIZACJI'}
                           section={'competition'}
                           backgroundColor={'#1F1F1F'}
                           style={{marginTop: 30, marginBottom: 30}}
            />
        </SectionContainer>
        <MatchesTable>
            <TableHeader>{'WYNIKI OSTATNICH ROZEGRANYCH SPOTKAŃ'}</TableHeader>
            { isFetching ? <LoadingSpinner/> : (!isFetching && matches.length) ? renderMatches() : <MatchesInfoText>{'Brak danych do wyswietlenia.'}</MatchesInfoText>}
            <TableSubheader>{'AKTUALNA SERIA ZWYCIĘSTW: '}<ColoredText
                color={'green'}>{winStreak}</ColoredText></TableSubheader>
            <Logo style={{
                position: 'absolute',
                right: -100,
                top: -100,
                transform: 'rotate(5deg)',
                opacity: 0.1,
                zIndex: 0
            }}/>
        </MatchesTable>
    </Section>);
};

export default Matches;
